import { render } from "./ToggleSettings.vue?vue&type=template&id=b8a9f4f6"
import script from "./ToggleSettings.vue?vue&type=script&lang=js"
export * from "./ToggleSettings.vue?vue&type=script&lang=js"

import "./ToggleSettings.vue?vue&type=style&index=0&id=b8a9f4f6&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__